
/* AUTOSIZE */

!function (e, t) { if ("function" === typeof define && define.amd) define(["exports", "module"], t); else if ("undefined" !== typeof exports && "undefined" !== typeof module) t(exports, module); else { var n = { exports: {} }; t(n.exports, n), e.autosize = n.exports; } }(this, function (e, t) { "use strict"; function n(e) { function t() { var t = window.getComputedStyle(e, null); "vertical" === t.resize ? e.style.resize = "none" : "both" === t.resize && (e.style.resize = "horizontal"), s = "content-box" === t.boxSizing ? -(parseFloat(t.paddingTop) + parseFloat(t.paddingBottom)) : parseFloat(t.borderTopWidth) + parseFloat(t.borderBottomWidth), isNaN(s) && (s = 0), l(); } function n(t) { var n = e.style.width; e.style.width = "0px", e.offsetWidth, e.style.width = n, e.style.overflowY = t; } function o(e) { for (var t = []; e && e.parentNode && e.parentNode instanceof Element;)e.parentNode.scrollTop && t.push({ node: e.parentNode, scrollTop: e.parentNode.scrollTop }), e = e.parentNode; return t; } function r() { var t = e.style.height, n = o(e), r = document.documentElement && document.documentElement.scrollTop; e.style.height = ""; var i = e.scrollHeight + s; return 0 === e.scrollHeight ? void (e.style.height = t) : (e.style.height = i + "px", u = e.clientWidth, n.forEach(function (e) { e.node.scrollTop = e.scrollTop; }), void (r && (document.documentElement.scrollTop = r))); } function l() { r(); var t = Math.round(parseFloat(e.style.height)), o = window.getComputedStyle(e, null), i = "content-box" === o.boxSizing ? Math.round(parseFloat(o.height)) : e.offsetHeight; if (i !== t ? "hidden" === o.overflowY && (n("scroll"), r(), i = "content-box" === o.boxSizing ? Math.round(parseFloat(window.getComputedStyle(e, null).height)) : e.offsetHeight) : "hidden" !== o.overflowY && (n("hidden"), r(), i = "content-box" === o.boxSizing ? Math.round(parseFloat(window.getComputedStyle(e, null).height)) : e.offsetHeight), a !== i) { a = i; var l = d("autosize:resized"); try { e.dispatchEvent(l); } catch (e) { var aerials = 0; } } } if (e && e.nodeName && "TEXTAREA" === e.nodeName && !i.has(e)) { var s = null, u = e.clientWidth, a = null, c = function () { e.clientWidth !== u && l(); }, p = function (t) { window.removeEventListener("resize", c, !1), e.removeEventListener("input", l, !1), e.removeEventListener("keyup", l, !1), e.removeEventListener("autosize:destroy", p, !1), e.removeEventListener("autosize:update", l, !1), Object.keys(t).forEach(function (n) { e.style[n] = t[n]; }), i.delete(e); }.bind(e, { height: e.style.height, resize: e.style.resize, overflowY: e.style.overflowY, overflowX: e.style.overflowX, wordWrap: e.style.wordWrap }); e.addEventListener("autosize:destroy", p, !1), "onpropertychange" in e && "oninput" in e && e.addEventListener("keyup", l, !1), window.addEventListener("resize", c, !1), e.addEventListener("input", l, !1), e.addEventListener("autosize:update", l, !1), e.style.overflowX = "hidden", e.style.wordWrap = "break-word", i.set(e, { destroy: p, update: l }), t(); } } function o(e) { var t = i.get(e); t && t.destroy(); } function r(e) { var t = i.get(e); t && t.update(); } var i = "function" === typeof Map ? new Map : function () { var e = [], t = []; return { has: function (t) { return e.indexOf(t) > -1; }, get: function (n) { return t[e.indexOf(n)]; }, set: function (n, o) { e.indexOf(n) === -1 && (e.push(n), t.push(o)); }, delete: function (n) { var o = e.indexOf(n); o > -1 && (e.splice(o, 1), t.splice(o, 1)); } }; }(), d = function (e) { return new Event(e, { bubbles: !0 }); }; try { new Event("test"); } catch (e) { d = function (e) { var t = document.createEvent("Event"); return t.initEvent(e, !0, !1), t; }; } var l = null; "undefined" === typeof window || "function" !== typeof window.getComputedStyle ? (l = function (e) { return e; }, l.destroy = function (e) { return e; }, l.update = function (e) { return e; }) : (l = function (e, t) { return e && Array.prototype.forEach.call(e.length ? e : [e], function (e) { return n(e, t); }), e; }, l.destroy = function (e) { return e && Array.prototype.forEach.call(e.length ? e : [e], o), e; }, l.update = function (e) { return e && Array.prototype.forEach.call(e.length ? e : [e], r), e; }), t.exports = l; });
/* FINE AUTOSIZE */

var exchangeinfo_win_tocheck;
var exchangeinfo_postback_source;

exchangeinfo_win_tocheck = null;

//window.html2canvas = html2canvas;

function CleanHTML(TextToConvert, Mode) {

    TextToConvertClear = TextToConvert.toString()

    if (Mode == 1) {


        TextToConvertClear = TextToConvertClear.replaceAll('***', '"')
        TextToConvertClear = TextToConvertClear.replaceAll("&amp;", "&")
        TextToConvertClear = TextToConvertClear.replaceAll("&lt;", "<")
        TextToConvertClear = TextToConvertClear.replaceAll("&gt;", ">")
        TextToConvertClear = TextToConvertClear.replaceAll("&nbsp;", " ")




    }
    else {
        TextToConvertClear = TextToConvertClear.replaceAll('"', '***')
        TextToConvertClear = TextToConvertClear.replaceAll("&", "&amp;")
        TextToConvertClear = TextToConvertClear.replaceAll("<", "&lt;")
        TextToConvertClear = TextToConvertClear.replaceAll(">", "&gt;")
        TextToConvertClear = TextToConvertClear.replaceAll(" ", "&nbsp;")

    }

    TextToConvertClear = TextToConvertClear.replace(/[\x00-\x13]/g, ' ');
    TextToConvertClear = TextToConvertClear.replace(/[\x7F-\x7F]/g, ' ');
    TextToConvertClear = TextToConvertClear.replace(/[\xA0-\xA0]/g, ' ');
    TextToConvertClear = TextToConvertClear.replace(/[\xAD-\xAD]/g, ' ');

    return TextToConvertClear;
}

function VerifyManager(ElementID) {
    var HTMLHiddenElementToVerify;
    if (ElementID == '') { return true; }
    else {
        
        HTMLHiddenElementToVerify = document.getElementById(ElementID)
        if (HTMLHiddenElementToVerify == null) { alert('Verifica Manager non riuscita'); return false; }
        else {
            if (HTMLHiddenElementToVerify.value == '') {
                if (confirm('Il ruolo di manager non è stato specificato, si vuole proseguire?')) { return true; } else { return false; } } else { return true; }
        }
        
    }
}



function italianTimeFormat(dateUTC) {
    var month = ("0" + (dateUTC.getMonth() + 1)).slice(-2);
    var day = ("0" + (dateUTC.getDate())).slice(-2);
    var year = dateUTC.getFullYear();
    var hour = ("0" + (dateUTC.getHours())).slice(-2);
    var min = ("0" + (dateUTC.getMinutes())).slice(-2);
    var seg = ("0" + (dateUTC.getSeconds())).slice(-2);
    return (day.toString() + '/' + month.toString() + '/' + year.toString() + ' ' + hour.toString() + ":" + min.toString() + ":" + seg.toString()).toString();

}


function CreateExcelFromHTML(ElementToPrint, Title) {

    // Get the HTML table element
    var JS_HTML_TableToPrint = document.getElementById(ElementToPrint);

    // Verifica che l'elemento esista
    if (!JS_HTML_TableToPrint) {
        alert("Errore: elemento da esportare non trovato");
        return;
    }

    if (JS_HTML_TableToPrint.rows.length <= 0) {
        alert("Errore: nessun dato da esportare");
        return;
    }

    var JScloned = JS_HTML_TableToPrint.cloneNode(true);



    var Columns = JScloned.rows[0].cells.length;


    var row = JScloned.insertRow(0);
    // Insert new cells (<td> elements) at the 1st and 2nd position of the "new" <tr> element:
    var cellHeader = row.insertCell(0);
    cellHeader.colspan = Columns;
    cellHeader.innerHTML = '';

    var row = JScloned.insertRow(0);
    // Insert new cells (<td> elements) at the 1st and 2nd position of the "new" <tr> element:
    var cellHeader = row.insertCell(0);
    cellHeader.colspan = Columns;
    cellHeader.innerHTML = 'Stampa del ' + italianTimeFormat(new Date()).toString();

    var row = JScloned.insertRow(0);
    // Insert new cells (<td> elements) at the 1st and 2nd position of the "new" <tr> element:
    var cellHeader = row.insertCell(0);
    cellHeader.colspan = Columns;
    cellHeader.innerHTML = Title;

    // Convert the HTML table to a workbook
    var workbook = XLSX.utils.table_to_book(JScloned, { sheet: "Esportazione Pyxis", raw: true });

    // Generate an Excel file and trigger the download
    XLSX.writeFile(workbook, 'Pyxis_Export.xlsx');


}




// Funzione che stampa il calendario in PDF
function CreatePDFfromHTML(ElementToPrint) {

    // DOCUMENTAZIONE:   https://artskydj.github.io/jsPDF/docs/jsPDF.html

    // Elemento da stampare
    var JSelementToPrint = document.getElementById(ElementToPrint);

    // Verifica che l'elemento esista
    if (!JSelementToPrint) {
        alert("Errore: elemento da stampare non trovato");
        return;
    }

    var JScloned = JSelementToPrint.cloneNode(true);

    JScloned.innerHTML = JScloned.innerHTML.replaceAll('</green>', '</div>').replaceAll('<green>', '<div class="sp_pdfprint_color_box sp_pdfprint_green">')
    JScloned.innerHTML = JScloned.innerHTML.replaceAll('</yellow>', '</div>').replaceAll('<yellow>', '<div class="sp_pdfprint_color_box sp_pdfprint_yellow">')
    JScloned.innerHTML = JScloned.innerHTML.replaceAll('</red>', '</div>').replaceAll('<red>', '<div class="sp_pdfprint_color_box sp_pdfprint_red">')




    var selects = JScloned.getElementsByTagName("select");

    for (i = 0; i < selects.length; i++) {
        selects[i].classList.add("sp_pdfprint_select");
    }

    //Rimuovo le classi dal clone da stampare
    var RemoveClasses;
    var AddClasses;

    RemoveClasses = JScloned.getElementsByClassName("sp_customers");
    for (i = 0; i < RemoveClasses.length; i++) {
        RemoveClasses[i].classList.remove("sp_customers");
    }

    RemoveClasses = JScloned.getElementsByClassName("sp_show_before_pdf");
    for (i = 0; i < RemoveClasses.length; i++) {
        RemoveClasses[i].classList.remove("d-none");
    }

    RemoveClasses = JScloned.getElementsByClassName("ckl_wp_caption_2");
    for (i = 0; i < RemoveClasses.length; i++) {
        RemoveClasses[i].classList.remove("d-none");
    }

    AddClasses = JScloned.getElementsByClassName("ckl_wp_caption_1");
    for (i = 0; i < AddClasses.length; i++) {
        AddClasses[i].classList.add("d-none");
    }

    AddClasses = JScloned.getElementsByClassName("sp_hide_before_pdf");
    for (i = 0; i < AddClasses.length; i++) {
        AddClasses[i].classList.add("d-none");
    }

    // Crea un nuovo documento PDF
    const { jsPDF } = window.jspdf;
    const doc = new jsPDF();

    // Aggiungi il contenuto dell'elemento al PDF
    doc.html(JScloned, {
        autoPaging: 'text',
        margin: [10, 5, 10, 5],
        callback: function (doc) {
            // Salva il PDF

            doc.save("PyxisSuite_ExtractPDF.pdf");
        },
        x: 10,
        y: 10,
        width: 190, // Larghezza del contenuto nel PDF
        windowWidth: JSelementToPrint.offsetWidth // Larghezza della finestra
    });
}



function Pyxis_Dashboard_OnSubmit() {
    var ControlThatCausedPostBack_Id = document.getElementById("__EVENTTARGET").value;
}


function sp_checkpage(window_tocheck, postback_source) {
    exchangeinfo_win_tocheck = window_tocheck;
    exchangeinfo_postback_source = postback_source;

    setInterval(PostbackOnWindowsClose, 100);

}


function GetCTLSafeObjectById(ObjectId) {
    TestObject = document.getElementById(ObjectId);
    if (TestObject == null) {
        ObjectId = ObjectId.replace('ctl00_', '');
        TestObject = document.getElementById(ObjectId);
    }

    return TestObject;
}

function GetCTLSafeObjectByName(ObjectName) {

    TestObject = document.getElementsByName(ObjectName);
    if (TestObject == null) {
        ObjectName = ObjectName.replace('ctl00_', '');
        TestObject = document.getElementsByName(ObjectName);
    }

    return TestObject;
}

function VerifyUploadDimensions(FileUploadID, FileTypes, maxFileSize, maxFiles) {
    // 4MB -> 4 * 1024 * 1024
    //FileTypes è nel formato |ext||ext|...|ext|
    var fileUpload = $('#' + FileUploadID);


    var Files = fileUpload[0].files;

    if (maxFiles < 0) {
        maxFiles = 0;
    }

    if (Files.length == 0) {
        alert('Occorre selezionare un file')
        fileUpload.val('');
        return false;

    }

    if (maxFiles > 0 && Files.length > maxFiles) {
        alert('Il numero massimo di file è ' + maxFiles.toString());
        fileUpload.val('');
        return false;

    }

    FileTypes = FileTypes.toLowerCase();
    if (FileTypes == '') {
        alert('Non è stata specificata nessuna tipologia di file valida')
        fileUpload.val('');
        return false;
    }


    for (var i = 0; i < Files.length; i++) {

        var fileExtension = Files[i].name.split('.').pop();
        fileExtension = fileExtension.toLowerCase();

        if (!(FileTypes.includes('|' + fileExtension + '|'))) {
            alert('La tipologia di file non è ammessa.\nFile: ' + Files[i].name + '\nTipologia del file: ' + fileExtension + '\n\n' + 'Tipologie ammesse: ' + (FileTypes.replaceAll('||', ' - ')).replaceAll('|', ''));
            fileUpload.val('');
            return false;
        }


        if (Files[i].size > (maxFileSize * 1024 * 1024)) {
            alert('Il file selezionato ha dimensioni eccessive.\nDimensioni del file: ' + (Math.round(Files[i].size / 1024 / 1024)).toFixed(2) + ' MB' + '\n' + 'Dimensione massima ammessa: ' + (Math.round(maxFileSize)).toFixed(2) + ' MB');
            fileUpload.val('');
            return false;
        }



    }


    return true;
}


function GetDateTime() {
    var currentdate = new Date;
    var datetime = currentdate.getDate().toString().padStart(2, '0') + "/"
        + (currentdate.getMonth() + 1).toString().padStart(2, '0') + "/"
        + currentdate.getFullYear() + " "
        + currentdate.getHours().toString().padStart(2, '0') + ":"
        + currentdate.getMinutes().toString().padStart(2, '0') + ":"
        + currentdate.getSeconds().toString().padStart(2, '0');

    return datetime;
}

function PostbackOnWindowsClose() {
    if (exchangeinfo_win_tocheck) {
        if (exchangeinfo_win_tocheck.closed) {
            exchangeinfo_win_tocheck = null;
            ClientDoPostback(exchangeinfo_postback_source);
        }
    }


}

function Dashboard_ResetFilters(CallerID) {
    if (CallerID === 100) {
        $('.dashboard_' + CallerID + ' input[type="text"]').first().val('');
        $('.dashboard_' + CallerID + ' input[type="checkbox"]').first().prop("checked", false);
        $('.dashboard_' + CallerID + ' select').first().val('-1');
        GetHTML(100, '', '', 0);

    }

}

function GetHTML(CallerID, URL, Destination, Repeat) {
    var Parameters;
    var URLComplete;
    var IdResultsType;
    var StatusID;
    //  CallerID: 
    //  100 Dashboard - Stato commesse per utente

    Parameters = '';
    RepeatMinutes = 0;
    IdResultsType = 1;
    StatusID = '';
    CallerID = $.trim(CallerID);
    URL = $.trim(URL);
    URLComplete = URL;

    if (CallerID === '100') {
        URL = 'SP_JSon.aspx';
        URLComplete = URL;
        URLComplete = URLComplete + '?prof=dashboard_' + CallerID + '&text=';
        URLComplete = URLComplete + '&F1=' + encodeURIComponent($('.dashboard_' + CallerID + ' input[type="text"]').first().val());
        URLComplete = URLComplete + '&F2=' + $('.dashboard_' + CallerID + ' input[type="checkbox"]').first().is(":checked");
        URLComplete = URLComplete + '&F3=' + $('.dashboard_' + CallerID + ' select').first().val();
        $('.dashboard_' + CallerID).find("*").prop("disabled", true);
        Destination = $('.dashboard_' + CallerID + ' div.dashboard_results').first().attr('id');
        StatusID = $('.dashboard_' + CallerID + ' span.PanelElements').first().attr('id');
        if (Repeat) {
            RepeatMinutes = 5;
        }

        IdResultsType = 2;
    }

    if (URL === '') {
        if (StatusID !== '') {
            $('#' + StatusID).html('Impossibile identificare la sorgente dei dati');
            $('#' + StatusID).prop('title', '');
        }

    }
    else {

        if (StatusID !== '') {
            $('#' + StatusID).html('<yellow>Aggiornamento in corso ...</yellow>');
            $('#' + StatusID).prop('title', '');
        }

        $('#' + Destination).html('');

        $.get(URLComplete, Parameters)
            .done(function (data) {

                var Status;
                var List;

                Status = '';
                List = data;

                if (IdResultsType === 2) {
                    Status = data.substring(0, 8);
                    List = data.substring(8);
                    $('.dashboard_' + CallerID).find("*").prop("disabled", false);

                }


                if (StatusID !== '') {
                    $('#' + StatusID).html('Elementi : ' + parseInt(Status));
                    $('#' + StatusID).prop('title', 'Ultimo aggiornamento: ' + GetDateTime());

                }
                $('#' + Destination).html(List);
            })
            .fail(function (data) {
                if (StatusID !== '') {
                    $('#' + StatusID).html('');
                }
                $('#' + Destination).html('<red>Si è verificato un errore, impossibile aggiornare i dati</red>');
            })
            ;

        if (RepeatMinutes > 0) {
            setTimeout(function () { GetHTML(CallerID, URL, Destination); }, 1000 * 60 * RepeatMinutes);    //  Rendo la chiamata ciclica 
        }

    }



}


function MaximizeBrowser() {
}


function sleep(milliseconds) {
    var start = new Date().getTime();
    for (var i = 0; i < 1e7; i++) {
        if (new Date().getTime() - start > milliseconds) {
            break;
        }
    }
}

function Trim(stringa) {
    if (!stringa) { stringa = ''; }

    while (stringa.substring(0, 1) === ' ') {
        stringa = stringa.substring(1, stringa.length);
    }
    while (stringa.substring(stringa.length - 1, stringa.length) === ' ') {
        stringa = stringa.substring(0, stringa.length - 1);
    }
    return stringa;
}

function Left(str, n) {
    if (n <= 0)
        return "";
    else if (n > String(str).length)
        return str;
    else
        return String(str).substring(0, n);
}



function Right(str, n) {
    if (n <= 0)
        return "";
    else if (n > String(str).length)
        return str;
    else {
        var iLen = String(str).length;
        return String(str).substring(iLen, iLen - n);
    }
}



function isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}





function ObjectExecCommand(Object_IdProfile, OperationDropDownID) {

    var objcboOperations;
    var Object_Id;
    var Object_Values;
    var Object_Title;
    var IdDocumentVersion;
    var UpdateSequence;
    var IsWindowRedirected;
    var TestObject;



    if (Object_IdProfile === null || typeof Object_IdProfile === 'undefined') {
        alert('Operazione fallita. (SCRIPT CODE:102)');
        return false;
    }

    if (OperationDropDownID === null || typeof OperationDropDownID === 'undefined') {
        alert('Operazione fallita. (SCRIPT CODE:103)');
        return false;
    }


    if (Object_IdProfile <= 0 || OperationDropDownID === '') {
        alert('Operazione fallita. (SCRIPT CODE:104)');
        return false;
    }


    TestObject = document.getElementById('ctl00_cphNavigation_' + OperationDropDownID);
    if (TestObject == null) {

        TestObject = document.getElementById('cphNavigation_' + OperationDropDownID);
        OperationDropDownID = 'cphNavigation_' + OperationDropDownID;
    }
    else {
        OperationDropDownID = 'ctl00_cphNavigation_' + OperationDropDownID;
    }

    if (TestObject === null) {
        alert('Operazione fallita. (SCRIPT CODE:105)');
        return false;
    }


    objcboOperations = document.getElementById(OperationDropDownID);

    if (objcboOperations === null) {
        alert('Operazione fallita. (SCRIPT CODE:106)');
        return false;
    }

    Object_Id = Right(OperationDropDownID, 8);

    TestObject = GetCTLSafeObjectById('ctl00_cphNavigation_ItemValues_' + Object_Id);
    if (TestObject === null) {
        alert('Operazione fallita. (SCRIPT CODE:107)');
        return false;
    }

    Modal_ShowWait('', 'Esecuzione operazione in corso ...');
    Object_Values = TestObject.value;

    IdDocumentVersion = -1;
    if (Object_IdProfile === 33) {
        IdDocumentVersion = Left(Object_Values, 8);
    }

    UpdateSequence = Object_Values.substring(8, 16);

    Object_Title = String(Object_Values).substring(16, 100);
    IsWindowRedirected = false;

    if (objcboOperations.value === 'EX') {
        IsWindowRedirected = true;
        if (Object_IdProfile === 33) {
            window.location.replace('SPHiddenCommands.aspx?Type=EX&IdProfile=48&Id=' + IdDocumentVersion + '&Caption=' + Object_Title);
        }
        else {
            window.location.replace('SPHiddenCommands.aspx?Type=EX&IdProfile=' + Object_IdProfile + '&Id=' + Object_Id + '&Caption=' + Object_Title);
        }

    }



    if (objcboOperations.value === 'D') {
        IsWindowRedirected = true;
        window.location.replace('SPHiddenCommands.aspx?Type=D&IdProfile=' + Object_IdProfile + '&Id=' + Object_Id + '&UpdateSequence=' + UpdateSequence + '&Caption=' + Object_Title);
    }



    if (objcboOperations.value === 'C') {
        IsWindowRedirected = true;
        window.location.replace('SPHiddenCommands.aspx?Type=C&IdProfile=' + Object_IdProfile + '&Id=' + Object_Id + '&UpdateSequence=' + UpdateSequence + '&Caption=' + Object_Title);
    }

    if (objcboOperations.value === 'RS') {
        IsWindowRedirected = true;
        window.location.replace('SPHiddenCommands.aspx?Type=RS&IdProfile=' + Object_IdProfile + '&Id=' + Object_Id + '&UpdateSequence=' + UpdateSequence + '&Caption=' + Object_Title);
    }

    if (Left(objcboOperations.value, 12) === 'SET_SUBLEAD_') {
        IsWindowRedirected = true;
        window.location.replace('SPHiddenCommands.aspx?Type=' + objcboOperations.value + '&IdProfile=' + Object_IdProfile + '&Id=' + Object_Id + '&UpdateSequence=' + UpdateSequence + '&ConfirmationStatus=1');
    }


    if (objcboOperations.value === 'SEL') {
        IsWindowRedirected = true;
        window.location.replace('SPHiddenCommands.aspx?Type=SEL&IdProfile=' + Object_IdProfile + '&Id=' + Object_Id + '&UpdateSequence=' + UpdateSequence + '&Caption=' + Object_Title);
    }

    if (objcboOperations.value === 'USL') {
        IsWindowRedirected = true;
        window.location.replace('SPHiddenCommands.aspx?Type=USL&IdProfile=' + Object_IdProfile + '&Id=' + Object_Id + '&UpdateSequence=' + UpdateSequence + '&Caption=' + Object_Title);
    }


    if (objcboOperations.value === 'ACC') {
        IsWindowRedirected = true;
        window.location.replace('SPHiddenCommands.aspx?Type=ACC&IdProfile=' + Object_IdProfile + '&Id=' + Object_Id + '&UpdateSequence=' + UpdateSequence + '&Caption=' + Object_Title);
    }

    if (objcboOperations.value === 'NAC') {
        IsWindowRedirected = true;
        window.location.replace('SPHiddenCommands.aspx?Type=NAC&IdProfile=' + Object_IdProfile + '&Id=' + Object_Id + '&UpdateSequence=' + UpdateSequence + '&Caption=' + Object_Title);
    }
    if (objcboOperations.value === 'RCC') {
        IsWindowRedirected = true;
        window.location.replace('SPHiddenCommands.aspx?Type=RCC&IdProfile=' + Object_IdProfile + '&Id=' + Object_Id + '&UpdateSequence=' + UpdateSequence + '&Caption=' + Object_Title);
    }
    if (objcboOperations.value === 'NAW') {
        IsWindowRedirected = true;
        window.location.replace('SPHiddenCommands.aspx?Type=NAW&IdProfile=' + Object_IdProfile + '&Id=' + Object_Id + '&UpdateSequence=' + UpdateSequence + '&Caption=' + Object_Title);
    }
    Modal_Hide();
    if (IsWindowRedirected === false) { alert('Opzione non riconosciuta. (SCRIPT CODE:108)'); }
    return false;
}




function ClearBugs() {

}



function ShowNavigation() {
    var ElementToShow;

    ElementToShow = GetCTLSafeObjectById("ctl00_divNavigation");

    if (ElementToShow != null) { ElementToShow.style.visibility = "visible"; }

}


function RequestConfirm(IdRequesteType) {
    var answer = false;

    switch (IdRequesteType) {
        /* Richiesta approvazione */
        case 1: answer = confirm('Gli elementi selezionati verranno approvati.\r\nProseguire?'); break;

        /* Richiesta autorizzazione */
        case 2: answer = confirm('Gli elementi selezionati verranno autorizzati.\r\nProseguire?'); break;

        /* Richiesta spostamento */
        case 3: answer = confirm('Gli elementi selezionati verranno spostati come indicato.\r\nProseguire?'); break;

        /* Conferma attivazione */
        case 4: answer = confirm('Gli elementi selezionati verranno attivati.\r\nProseguire?'); break;

        /* Conferma eliminazione */
        case 5: answer = confirm('Gli elementi selezionati verranno rimossi.\r\nProseguire?'); break;

        /* Conferma sospensione */
        case 6: answer = confirm('Gli elementi selezionati verranno sospesi.\r\nProseguire?'); break;

        /* Conferma sblocco */
        case 7: answer = confirm('Gli elementi selezionati verranno sbloccati.\r\nProseguire?'); break;

        /* Conferma spostamento */
        case 8: answer = confirm('Gli elementi attualmente negli appunti verranno spostati.\r\nProseguire?'); break;

        /* Conferma ricostruzione */
        case 9: answer = confirm('La lista selezionata verrà ricostruita, saranno possibili delle eliminazioni.\r\nProseguire?'); break;

        /* Conferma update di sistema */
        case 10: answer = confirm('Le informazioni modificate non potranno essere recuperate.\r\nProseguire?'); break;

        /* Conferma ripristino valore originale */
        case 11: answer = confirm('Gli elementi selezionati verranno reimpostati al loro valore originale.\r\nProseguire?'); break;

        /* Conferma ricalcolo */
        case 12: answer = confirm('Gli elementi selezionati verranno ricalcolati e modificati come indicato.\r\nProseguire?'); break;

        /* Conferma annullamento */
        case 14: answer = confirm('Gli elementi selezionati verranno annullati senza essere eliminati.\r\nProseguire?'); break;

        /* Conferma completamento */
        case 15: answer = confirm('Gli elementi selezionati verranno completati.\r\nProseguire?'); break;

        /* Conferma rifiuto cliente */
        case 16: answer = confirm('Gli elementi selezionati verranno segnalati come rifiutati dal cliente.\r\nProseguire?'); break;

        /* Conferma accettazione cliente */
        case 17: answer = confirm('Gli elementi selezionati verranno segnalati come accettati dal cliente.\r\nProseguire?'); break;

        /* Conferma invio cliente */
        case 18: answer = confirm('Gli elementi selezionati verranno segnalati come inviati al cliente.\r\nProseguire?'); break;

        /* Conferma emissione fattura */
        case 19: answer = confirm('Verrà emessa una fattura con i parametri selezionati.\r\nProseguire?'); break;

        /* Conferma aggiornamento versione */
        case 20: answer = confirm('I dati verranno aggiornati a partire dalla data indicata.\r\nNon sarà possibile annullare la modifica.\r\nProseguire?'); break;

        /* Conferma CKL Freeze */
        case 21: answer = confirm('La procedura verrà resa definitiva e verranno inviate le eventuali richieste di approvazione.\r\nProseguire?'); break;

        /* Conferma CKL Complete */
        case 22: answer = confirm('La procedura verrà firmata.\r\nProseguire?'); break;

        /* Conferma CKL Unfreeze */
        case 23: answer = confirm('La procedura verrà resa di nuovo modificabile.\r\nProseguire?'); break;

        /* Conferma CKL Uncomplete */
        case 24: answer = confirm('La procedura verrà riaperta rimuovendo la firma.\r\nProseguire?'); break;

        /* Conferma assegnazione Sublead */
        case 25: answer = confirm('Il conto verrà assegnato alla sublead selezionata.\r\nProseguire?'); break;

        /* Conferma resa definitiva documenti */
        case 26: answer = confirm('I documenti selezionati verranno resi definitivi se possibile.\r\nProseguire?'); break;

        /* Conferma resa definitiva documenti */
        case 27: answer = confirm('La lista dei KeyControl assegnati al ciclo di bilancio verrà approvata.\r\nProseguire?'); break;

        /* Conferma invio richiesta */
        case 28: answer = confirm('La richiesta verrà inviata.\r\nProseguire?'); break;

        default: answer = false; break;
    }


    return answer;
}


/* FV 2026-05-28 - Esegue l'operazione selezionata nel dropdown "Operazioni disponibili".
   Se la voce selezionata ha un attributo data-confirm > 0, mostra il confirm tramite
   RequestConfirm(N) (riusando i codici gia' esistenti sopra). Se data-confirm = 0 o assente
   va dritta senza confirm (replica del comportamento dei vecchi pulsanti Taglia / Mark
   che non avevano confirm). */
function ExecuteMoreAction(ddlId) {
    var ddl = document.getElementById(ddlId);
    if (!ddl) return false;

    if (ddl.value === '-1' || ddl.value === '') {
        alert("Seleziona un'operazione da eseguire.");
        return false;
    }

    var selOpt = ddl.options[ddl.selectedIndex];
    var requestType = parseInt(selOpt.getAttribute('data-confirm') || '0');

    if (requestType > 0) {
        if (!RequestConfirm(requestType)) return false;
    }

    Modal_ShowWait('', selOpt.text + ' in corso...');
    return true;
}


function DisplayMessage(MsgText, IdType, RedirectURLOnYes, RedirectURLOnNo) {

    var answer = false;

    if (IdType === 1) {
        alert(MsgText);
        if (RedirectURLOnYes !== '') { window.location.href = RedirectURLOnYes; }
    }

    if (IdType === 2) {
        answer = confirm(MsgText);
        if (answer)

            if (RedirectURLOnYes !== '') { window.location.href = RedirectURLOnYes; }
    }


    if (answer) { if (RedirectURLOnYes !== '') { window.location.href = RedirectURLOnYes; } }
    else { if (RedirectURLOnNo !== '') { window.location.href = RedirectURLOnNo; } }
}




function OnlyNumbers(evt) {
    var charCode = evt.which ? evt.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57))
        return false;
    return true;
}



function OnlyNumbersAndMinus(evt) {
    var charCode = evt.which ? evt.which : event.keyCode;
    if (charCode > 31 && charCode !== 45 && (charCode < 48 || charCode > 57))
        return false;
    return true;
}



function OnlyNumbersAndDecimalPoint(Source, evt) {
    var charCode = evt.which ? evt.which : event.keyCode;

    if (String(Source.value).indexOf(",") >= 0 && charCode === 44)
        return false;

    if (charCode > 31 && charCode !== 44 && (charCode < 48 || charCode > 57))
        return false;
    return true;
}





function OnlyNumbersAndSlash(evt) {
    if (evt) {
        var charCode = evt.which ? evt.which : event.keyCode;

        if (charCode > 31 && charCode !== 47 && (charCode < 48 || charCode > 57))
            return false;
    }
    return true;
}

function SetInputFieldValue(IdInputField, Value) {
    var objContainer = document.getElementById(IdInputField);
    objContainer.value = Value;
    return false;
}


function selectAll(field, SkipPostBack) {
    var objContainer = document.getElementById(field);

    if (objContainer === null || typeof objContainer === 'undefined') { return false; }

    if (objContainer.tagName === 'TABLE') {
        var Checkboxes = objContainer.getElementsByTagName('input');

        for (i = 0; i < Checkboxes.length; i++) {
            Checkboxes[i].checked = true;
        }
        if (!SkipPostBack) { __doPostBack(); }

    }
    else {
        for (i = 0; i < objContainer.length; i++) {
            objContainer[i].selected = true;
        }
    }
    return false;
}



function unselectAll(field, SkipPostBack) {
    var objContainer = document.getElementById(field);
    if (objContainer === null || typeof objContainer === 'undefined') { return false; }

    if (objContainer.tagName === 'TABLE') {
        var Checkboxes = objContainer.getElementsByTagName('input');

        for (i = 0; i < Checkboxes.length; i++) {
            Checkboxes[i].checked = false;
        }
        if (!SkipPostBack) { __doPostBack(); }
    }
    else {
        for (i = 0; i < objContainer.length; i++) {
            objContainer[i].selected = false;
        }
    }
    return false;
}



function selectAll_ByClass(ClassName, SkipPostBack) {

    $('input[type=checkbox].' + ClassName).prop('checked', true)

    var hidden_selection_all = $('#hidden_selection_multiple');
    var NewHiddenValue = '';

    if (hidden_selection_all != null) {
        hidden_selection_all.val("");   // Svuoto il Value del campo nascosto che tiene traccia delle checkbox selezionate

        $('input[type=checkbox].' + ClassName).each(function () {

            NewHiddenValue = hidden_selection_all.val() 

            if (NewHiddenValue != '') { NewHiddenValue = NewHiddenValue + ',' }

            NewHiddenValue = NewHiddenValue + $(this).attr('id');

            hidden_selection_all.val(NewHiddenValue );//Per ogni checkbox aggiungo il suo ID nel campo nascosto
        });

    }


    if (!SkipPostBack) { __doPostBack(); }
    return false;
}



function unselectAll_ByClass(ClassName, SkipPostBack) {
    $('input[type=checkbox].' + ClassName).prop('checked', false)

    var hidden_selection_all = $('#hidden_selection_multiple');

    if (hidden_selection_all != null) {
        hidden_selection_all.val("");
    }

    if (!SkipPostBack) { __doPostBack(); }
    return false;
}

function ClientDoPostback(PostBackSource) {
    if (PostBackSource.indexOf("_NO_WAIT_") >= 0) {
        PostBackSource = PostBackSource.replace('_NO_WAIT_', '')
    }
    else {
        setTimeout(function () { Modal_ShowWait('', 'Aggiornamento dati in corso...'); }, 50);
    }
    

    
    __doPostBack(PostBackSource, '');

}

function ChecboxCheckedStatusDetected(SourceCheckBoxId, HiddenDestinationFieldId) {
    /** Gestisce il cambiod el valore CHECKED di una casella memorizzando l'ID della checkbox modificata in un campo nascosto
    
    SourceCheckBoxId Indica l'id della casella checkbox che viene posta in checked
    
    HiddenDestinationFieldId indica l'ID di un input hidden
    
    **/
    var CheckBoxElement = document.getElementById(SourceCheckBoxId);
    var HiddenElement = document.getElementById(HiddenDestinationFieldId);
    var MustUpdateElementsLength = 0;

    if ((CheckBoxElement !== null) && (HiddenElement !== null)) {

        var MustUpdateElements = HiddenElement.value;

        if (CheckBoxElement.checked) {// La checkbox è checked
            if (MustUpdateElements.indexOf(SourceCheckBoxId) === -1) {
                if (MustUpdateElements === '')
                // L'elenco delle date da salvare è vuoto, lo riempio con la data in questione
                { HiddenElement.value = SourceCheckBoxId; }
                else
                // L'elenco delle date da salvare NON è vuoto, aggiungo la data in questione
                { HiddenElement.value = HiddenElement.value + ',' + SourceCheckBoxId; }
            }
        }
        else {// La checkbox è unchecked

            HiddenElement.value = HiddenElement.value.replace(SourceCheckBoxId + ',', '');
            HiddenElement.value = HiddenElement.value.replace(SourceCheckBoxId, '');

            MustUpdateElementsLength = HiddenElement.value.length;
            if (MustUpdateElementsLength > 0) {
                if (HiddenElement.value.charAt(MustUpdateElementsLength - 1) === ',') {
                    HiddenElement.value = Left(HiddenElement.value, MustUpdateElementsLength - 1);
                }
            }


        }

    }

}


function ElementsByClassName(ClassName) {
    if (typeof document.getElementsByClassName === 'undefined') {
        var hasClassName = new RegExp("(?:^|\\s)" + className + "(?:$|\\s)");
        var allElements = document.getElementsByTagName("*");
        var results = [];

        var element;
        for (var i = 0; (element = allElements[i]) !== null; i++) {
            var elementClass = element.className;
            if (elementClass && elementClass.indexOf(className) !== -1 && hasClassName.test(elementClass))
                results.push(element);
        }

        return results;
    }
    else
        return document.getElementsByClassName(ClassName);
}


function selectAllByClassName(ClassName) {
    var Elements = ElementsByClassName(ClassName);

    for (var i = 0; (element = Elements[i]) !== null; i++) {
        element.checked = true;
    }

    return false;
}


function unselectAllByClassName(ClassName) {
    var Elements = ElementsByClassName(ClassName);

    for (var i = 0; (element = Elements[i]) !== null; i++) {
        element.checked = false;
    }

    return false;
}


function CollapsePanel(PanelToCollapse) {
    var pnl = $find(PanelToCollapse);

    if (pnl !== null) { pnl._doClose(); }

}

function scrollToAnchor(hash) {
    location.hash = "#" + hash;
}

function refreshParent() {
    window.opener.location.reload();
}

function closeWindows() {

    window.open('', '_self', '');

    window.close();
}


function StoreCollectionIdProfile(Source) {
    var objTarget;

    objTarget = GetCTLSafeObjectById("ctl00_cphNavigation_hydCollectionsIdProfile");

    var objSource;

    if (Source === 1) {
        var Profiles = GetCTLSafeObjectByName("ctl00$cphNavigation$optCollections");
        if (Profiles) {
            for (var i = 0; i < Profiles.length; i++) {
                if (Profiles[i].checked === true) { objSource = Profiles[i]; }
            }
        }

    }

    if (Source === 2) {
        objSource = GetCTLSafeObjectById("ctl00_cphNavigation_cboMobileCollections");

    }

    if (objTarget && objSource) {
        objTarget.value = objSource.value;
    }


}



function StoreSelection(HiddenElement, ElementIdToCheck) {
    var objTarget = $('#' + HiddenElement);
    var CurrentSelectedIds = '';
    var CurrentValueAlreadyPresent = false;
    var objSource = $('#' + ElementIdToCheck);
    var SourceValue = '';
    var SourceIsChecked = false;

    if (objTarget && objSource) {
        SourceValue = objSource.prop("value");
        SourceIsChecked = objSource.prop("checked");
        CurrentSelectedIds = objTarget.prop("value");

        if (SourceValue !== '') {
            CurrentValueAlreadyPresent = false;

            if (CurrentSelectedIds.indexOf('|*' + SourceValue + '*|') >= 0) {
                CurrentValueAlreadyPresent = true;
            }

            if (SourceIsChecked) {
                if (!CurrentValueAlreadyPresent) { objTarget.prop('value', objTarget.prop("value") + '|*' + SourceValue + '*|,'); }
            }
            else {
                if (CurrentValueAlreadyPresent) { objTarget.value(objTarget.prop('value', objTarget.prop("value").replace('|*' + SourceValue + '*|,', ''))); }

            }

        }



    }


}

function Pyxis_HideCardBody() {
    var CardBody = ElementsByClassName('card-body');
    if (CardBody.length > 0) {
        CardBody[0].classList.remove("show");
    }
}

function Pyxis_Class_Remove(ElementId, ClassToAdd) {

    var ObjectToUse = document.getElementById(ElementID);

    if (!(ObjectToUse == null)) {
        ObjectToUse.classList.remove(ClassToAdd);
    }

}

function Pyxis_Class_Add(ElementId, ClassToAdd) {
    
    var ObjectToUse = document.getElementById(ElementID);

    if (!(ObjectToUse == null)) {

        Pyxis_Class_Remove(ElementId, ClassToAdd);

        ObjectToUse.classList.add(ClassToAdd);
    }

}



